<template>

<div class="textbox" :class="{'is-error': error}">

	<app-icon s="error" v-if="error" class="error" />
	
	<input class="textbox-input" type="text" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" :placeholder="input.label" />

</div>

</template>

<script>

export default {

	props: ['input', 'value', 'error']

}

</script>

<style scoped>

.textbox {
	margin-bottom: 20px;
}

.textbox-input {
	background-color: #f5f5f5;
	padding: 0px 20px;
	height: 46px;
	line-height: 46px;
	color: #1A234C;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 1.4px;
	border-radius: 23px;
	width: 100%;
}

.textbox-input::placeholder {
	color: #1A234C;
	font-size: 14px;
	font-weight: 500;
}

</style>
